function GetSizeOfColor(params) {
    var companyThemePath = "ECTR"

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetSizeOfColors",
        data: params,
        success: function (data) {

            $basketButton.parents(".AddToCartArea").find(".ProductListSizeContainer").html(data);
            var $firstSize = $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize.active:first");

            var firstSizeId = ($firstSize.length > 0 ? $firstSize.attr("data-size") : 0);

            $basketButton.removeClass("passive");

            if (firstSizeId === 0) {
                $basketButton.addClass("passive");
            }

            $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize").removeClass("active");
            $basketButton.parents(".AddToCartArea").children(".TransformContainer").addClass("select-size");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}

function GetImageOfColors(params, item_unique_id, $currentColor) {
    var companyThemePath = "ECTR";
    var lazyImage = "/Images/" + companyThemePath + "/lazy_back_new.jpg";
    Prd = $("#Prd" + item_unique_id);
    //Prd.addClass("loading");
    GenerateLocalLoading(Prd, "show");

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetImageOfColors",
        data: params,
        success: function (data) {

            $Crs = $("#Crs_" + item_unique_id);
            //$Crs.find("div.carousel-inner").html("");
            $Crs.html("");

            var urlNew = "";

            if (data.ProductUrl != undefined && data.ColorUrl != undefined) {
                urlNew += getRequestRoute() + "/" + data.ColorUrl + "-" + data.ProductUrl + "-" + data.ColorID;
            }

            if (data.ImgPath1 != null) {
                var $imgKucuk1 = $('<a href="' + urlNew + '" ><img class="img1 PImage img-responsive" src="' + data.ImgPath1 + '"></a>');

                $imgKucuk1.appendTo($Crs);
            }

            //if (data.ImgPath2 != null) {
            //    var $imgKucuk2 = $('<div class="carousel-item"><a href="' + urlNew + '" ><img class="img2 PImage img-responsive" src="' + lazyImage + '" data-img="' + data.ImgPath2 + '" ></a></div>');
            //    $imgKucuk2.appendTo($Crs.find("div.carousel-inner"));
            //}

            //AddToCart attributeleri değiştir
            $currentColor.closest(".Prd").find(".AddToCart").attr("data-colorid", data.ColorID);
            $currentColor.closest(".Prd").find(".AddToCart").attr("data-productid", data.ProductID);
            $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", data.SizeID);

            //sistemde tanımlı badgeler varsa eklenmeli.
            if (data.BadgeImagePath != null && data.BadgeImagePath != undefined && data.BadgeTur != 14) {
                $currentColor.closest(".Prd").find(".ProductBadge").html("");

                if (data.BadgeTur == 7) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 8) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 9) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 10) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                }

                //if (data.Amount < data.AmountOld) {
                //    if ($("#SmallLangCode").val() === "tr") {
                //        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/"+companyThemePath+"/badge/indirim_bagde.png'></div>");
                //    }
                //    else if ($("#SmallLangCode").val() === "en") {
                //        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/"+companyThemePath+"/badge/discount_badge.png'></div>");
                //    }
                //    else if ($("#SmallLangCode").val() === "fr") {
                //        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/"+companyThemePath+"/badge/rabais_badge.png'></div>");
                //    }
                //}
            }

            if (data.TotalQuantity <= 0) {
                $currentColor.closest(".Prd").find(".AddToCart").addClass("passive");
            }
            else {
                $currentColor.closest(".Prd").find(".AddToCart").removeClass("passive");
                $currentColor.closest(".Prd").find(".ProductBadge").find(".soldOutBadge").remove();
            }

            //Prd.find("img.PImage.img1").Lazy();
            GenerateLocalLoading(Prd, "hide");
        },
        error: function (xhr, status, error) {
            //var data = xhr.responseText;
            //var jsonResponse = JSON.parse(data);
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(Prd, "hide");
        }
    });
}

function IsfollowForProductDetails(ProductID, callback) {
    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/ProductDetails/IsFollow",
        data: 'ProductID=' + ProductID,
        dataType: 'json',
        async: true,
        success: function (dt) {
            callback(dt);
        }
    });
}

function GetProductInstalments(Amount) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetInstallmentOptions?Amount=" + Amount.replace(".", ""),
        success: function (data) {
            $(".InstallmentBody").html(data);
            $("#TaksitSecenekleri").modal();
            $('html, body').animate({
                scrollTop: $("#PdInstallmentOptionsDetail").offset().top - 50
            }, 500);
        }
    });
}

function GetProductWarn(data) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/StokWarn",
        data: data,
        success: function (data) {
            if (data != "0" && data != 0) {

                var prdCls = "More";

                $(".LastProducts").removeClass("One");
                $(".LastProducts").removeClass("Two");
                $(".LastProducts").removeClass("More");
                $(".LastProducts").removeClass("Limited");

                $(".LastX").html(data);
                $(".LastPrdHint").html($(".LastPrdHint").attr("data-more"));

                if (data.length > 1) {
                    $(".LastX").css("margin-left", "2px");
                }
                else {
                    $(".LastX").css("margin-left", "4px");
                }

                switch (data) {
                    case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                    case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                    case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                    case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                    case "4": prdCls = "Limited"; break;
                }

                $(".LastProducts").addClass(prdCls);
                $(".LastProducts").show();
            }
        }
    });
}

function ChangeProductColor(ProductID, ColorID, LangID, callback) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/getProductDetailAjax",
        data: "ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID,
        async: true,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($("#NewPd"), "show");
        },
        success: function (data) {
            alert("test");
            callback(data, true);
        },
        error: function () {
            callback("", false);
        },
        complete: function () {
            GenerateLocalLoading($("#NewPd"), "hide");
        }
    });
}

function GetListForRemind(data) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetListForRemind",
        data: data,
        cache: true,
        success: function (data) {

            $("#PrdBlackBg").hide();
            $(".SizeOptions.open").removeClass("PleaseSelect");
            $(".DropItems.PleaseSelect").removeClass("PleaseSelect");
            $(".AddToBasketOuther.PleaseSelect").removeClass("PleaseSelect");
            $("#RemindMeLater").addClass("active");

            if ($(".AutoTextRep").length > 0) {
                $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
            }

            $("#NotifyModal").modal("show");
            $("#NotifyModal").css("display", "flex");

            $("#NotifyModal .modal-body").html(data);
            $(".NotifyColors a:first").trigger("click");

            if (data != null && data != "" && data != undefined) {
                if (data.length < 300) {
                    $("#NotifyModal .modal-footer button").hide();
                }
                else {
                    $("#NotifyModal .modal-footer button").show();
                }
            }
        }
    });
}

function RemindMeWhenAvailable(data) {
    $.ajax({
        type: "POST",
        url: getRequestRoute() + "/p/ProductDetails/RemindMeWhenAvailable",
        data: data,
        dataType: "json",
        beforeSend: function () {
            GenerateLocalLoading($("#NotifyModal"), "show");
        },
        success: function (dt) {
            if (dt.Sonuc == true) {
                $("#NotifyModal").modal("hide");
                SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        },
        complete: function () {
            GenerateLocalLoading($("#NotifyModal"), "hide");
        }
    });
}

function AddToFavorite(ColorID, ProductID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddToFollowList",
        data: 'colorID=' + ColorID + "&productID=" + ProductID,
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                callback(true, "");
            }
            else {
                callback(false, getStandartMessages("FavorilerIcinGirisYapin"));
            }
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function removeFavorite(ProductID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/RemoveFromList",
        data: 'id=' + ProductID + "&IsDetail=true",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                callback(true);
            }
        },
        error: function () {
            callback(false);
        }
    });
}

function ChangeCombineSliderPhoto(data) {
    GenerateLocalLoading($(".ProductDetailImages"), "show");
    GenerateLocalLoading($(".SmallProductImages"), "show");

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetAllDetailInfoByColorID",
        data: data,
        success: function (data) {

            $(".ProductDetailImages > ul").slick('unslick');
            $(".ProductDetailImages > ul > li").remove();

            $(".SmallProductImages > ul").slick('unslick');
            $(".SmallProductImages > ul > li").remove();

            var c = 0;
            $.each(data.reverse(), function (k, v) {
                if (v.Type == "StockImage") {
                    c++;
                    var selected = "";
                    if (c == 1) {
                        selected = " Selected ";
                    }

                    $(".ProductDetailImages > ul").append('<li class="ImgArea fancybox ' + selected + '" href="' + v.Name.replace("_enbuyuk", "_buyuk") + '"><img src="' + v.Name.replace("_enbuyuk", "_buyuk") + '"  /></li>');

                    if ($(window).width() > 991) {
                        $(".SmallProductImages > ul").append('<li><img src="' + v.Name.replace("_buyuk", "_kucuk") + '" class="' + selected + '"  /></li>');
                    }
                }
            });

            SlickSlider(false);

            GenerateLocalLoading($(".ProductDetailImages"), "hide");
            GenerateLocalLoading($(".SmallProductImages"), "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            GenerateLocalLoading($(".ProductDetailImages"), "hide");
            GenerateLocalLoading($(".SmallProductImages"), "hide");
        }
    });
}

function GetLastVisitedData() {
    var LastVisitedPrds = [];
    var lastPrdsKey = "LastVisitedPrds-" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val();

    LastVisitedPrds = localStorage.getItem(lastPrdsKey);

    if (LastVisitedPrds == undefined) {
        LastVisitedPrds = [];
    }
    else {
        LastVisitedPrds = JSON.parse(LastVisitedPrds);
    }

    return LastVisitedPrds;
}

function GetLastVisitedPrdView(productData, callback) {
    if ($(".AutoGetLastVisited").length > 0) {
        $.ajax({
            type: "POST",
            url: getRequestRoute() + "/p/ProductDetails/GetLastVisitedProductsView",
            data: JSON.stringify(productData),
            //contentType:"text/html",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {
                callback(dt);
            }
        });
    }
}